import { IUser } from '@/interfaces/user'
import { GroupChannel } from '@sendbird/chat/groupChannel'

export const getChannelCoverSrc = (
  channel: GroupChannel,
  currentUserId: string
) => {
  if (!channel) return ''
  return (
    (channel.members || [])
      .filter((member) => member.userId !== currentUserId)
      .map((member) => member.profileUrl)[0] || '/assets/avatar.png'
  )
}

export const getChannelName = (channel: GroupChannel, userId: string) => {
  const channelMembersWithoutCurrentUser = channel.members.filter(
    (member) => member.userId !== userId
  )

  return (
    channelMembersWithoutCurrentUser
      .map((member) => member.nickname)
      .join(', ') || channel.name
  )
}

/**
 * Transformation of UserDto to SendBird User MetaData
 * @param user - UserDto
 * @returns - SendBird User MetaData
 */
export const userSendBirdMetaData = (user: IUser) => {
  const userMetaData = {}

  // Programmatically add the applicable fields
  // Trimming to 5 fields due to Sendbird constraints
  const fieldsToAdd = ['location', 'title', 'totalAudience', 'username']
  fieldsToAdd.forEach((property) => {
    if (user?.[property]) {
      userMetaData[property] = String(user[property])
    }
  })

  // Check to add company field
  if (user?.isEmployer?.companyName) {
    userMetaData['company'] = user.isEmployer.companyName
  }

  return userMetaData
}
